/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagesold2Inputs */

const en_ticketpagesold2 = /** @type {(inputs: Ticketpagesold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold`)
};

const de_ticketpagesold2 = /** @type {(inputs: Ticketpagesold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkauft`)
};

/**
* | output |
* | --- |
* | "Sold" |
*
* @param {Ticketpagesold2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagesold2 = /** @type {((inputs?: Ticketpagesold2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagesold2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagesold2(inputs)
	return de_ticketpagesold2(inputs)
});
export { ticketpagesold2 as "ticketPageSold" }